import { joinUrlParms } from '../Api/apiHelpers';
import apiEndpoint from '../apiEndpoint';

export const makeAuthUrl = (state, endpoint, urlParams) =>
	`${apiEndpoint}${endpoint}${urlParams ? joinUrlParms(urlParams) : ''}`;
